import { render, staticRenderFns } from "./project-dialog.vue?vue&type=template&id=b25adbcc&scoped=true"
import script from "./project-dialog.vue?vue&type=script&lang=js"
export * from "./project-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25adbcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b25adbcc')) {
      api.createRecord('b25adbcc', component.options)
    } else {
      api.reload('b25adbcc', component.options)
    }
    module.hot.accept("./project-dialog.vue?vue&type=template&id=b25adbcc&scoped=true", function () {
      api.rerender('b25adbcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/projects/components/project-dialog.vue"
export default component.exports